import { logEvent } from "@red-digital/bricks";

export type InstallmentScheduleEntry = {
  paymentLabel: string;
  dueDate: string;
  amountDueDisplay: string;
  amountDue: string;
};


export type PricingAPIInstallments =
  | {
      enabled: true;
      title: string;
      numberOfInstallments: number;
      description: string;
      schedule: InstallmentScheduleEntry[];
    }
  | {
      enabled: false;
      reason: string;
    };

export type PricingAPIPayload = {
  id: string;
  course: string;
  durationWeeks: number;
  duration: string;
  effort: string;
  currency: string;
  price: string;
  display_price: string;
  regCloseDate: string;
  startDate: string;
  endDate: string;
  installments?: PricingAPIInstallments;
};

export type PricingAPIError = {
  error: string;
};

const maxRetries = 3;
const baseDelay = 1000; // 1 second

const fetchWithRetry = async (
  program: string,
  cb: (data: PricingAPIPayload & PricingAPIError) => any,
  attempt: number = 1,
): Promise<void> => {
  try {
    const res = await fetch(`https://www.getsmarter.com/products/${program}.json`);
    const data = await res.json();

    cb(data || {});
  } catch (error) {
    if (attempt < maxRetries) {
      const delay = baseDelay * Math.pow(2, attempt - 1); // Exponential backoff: 1s, 2s, 4s

      setTimeout(() => {
        fetchWithRetry(program, cb, attempt + 1);
      }, delay);
    } else {
      cb({
        id: "",
        course: "",
        durationWeeks: 0,
        duration: "",
        effort: "",
        currency: "",
        price: "",
        display_price: "",
        regCloseDate: "",
        startDate: "",
        endDate: "",
        error: error instanceof Error ? error.message : "Unknown error",
      });

      logEvent("pricing_api_error", {
        error: JSON.stringify(error),
      });
    }
  }
};

export function getProgramPrice(program: string, cb: (data: PricingAPIPayload & PricingAPIError) => any) {
  fetchWithRetry(program, cb);
}
